export const NOTIFICATION_METHOD_TYPES = {
	FAX: 'fax',
	EMAIL: 'e-mail',
	LETTER: 'level'
};
export const FIELDS = {
	POS_TERMINAL_NUMBER: 'Pos terminál száma',
	AMEX_ID: 'Amex üzletazonosító',
	TRADE_CODE: 'Kereskedő kód',
	COMPANY_NAME: 'Üzlet neve',
	COMPANY_POSTCODE: 'Üzlet cím irányítószám',
	SETTLEMENT: 'Üzlet cím település',
	ADDRESS: 'Üzlet cím utca, házszám',
	CONTRIBUTOR_NAME: 'Bejelentő neve',
	CONTACT_PHONE_NUMBER: 'Kapcsolattartó telefon',
	CONTACT_FAX: 'Kapcsolattartó fax',
	CONTACT_EMAIL: 'Kapcsolattartó e-mail',
	COMPLAINT_SUBJECT: 'Reklamáció tárgya',
	TRANSACTION_TYPE: 'Tranzakció típusa',
	TRANSACTION_DATE: 'Tranzakció dátum',
	CARD_NUMBER: 'Rendelkezésre álló kártyaszám',
	LICENCE_NUMBER: 'Engedélyszám',
	TRANSACTION_AMOUNT: 'Tranzakció összege',
	TRANSACTION_CURRENCY: 'Tranzakció devizaneme',
	DISPUTE_AMOUNT: 'Vitatott összeg',
	DISPUTE_CURRENCY: 'Vitatott összeg devizaneme',
	LIST_AMOUNT: 'Tételes listán szereplő utalandó összeg',
	PAYMENT: 'Utalás összege',
	PAYMENT_CURRENCY: 'Utalandó összeg/utalás összegének devizaneme',
	PAYMENT_DATE: 'Utalás dátuma',
	COMMENT: 'Megjegyzés',
	DOCUMENT: 'Csatolt dokumentum',
	NOTIFICATION_METHOD: 'Értesítés módja',
	NOTIFICATION_METHOD_CONTACT: {
		[NOTIFICATION_METHOD_TYPES.FAX]: 'Értesítési fax',
		[NOTIFICATION_METHOD_TYPES.LETTER]: 'Értesítés levelezési cím',
		[NOTIFICATION_METHOD_TYPES.EMAIL]: 'Értesítési e-mail cím'
	}
};
export const COMMENT_AND_FILE_VALIDATION_COMPLAINT_SUBJECT =
	'Egyéb, pl. több tranzakció elszámolásával, napi átutalással kapcsolatos probléma (Megjegyzés, és a Csatolt dokumentum mezők kitöltése kötelező)';
export const MANDATORY_PAYMENT_VALIDATION_COMPLAINT_SUBJECT =
	'Tételes listán feltüntetett összeg és a hozzá kapcsolódó utalás összege nem egyezik';
export const NO_CARD_NUMBER_VALIDATION_TRANSACTION_TYPE = 'Internet, posta, telefonos rendelés';
export const WEKA_DATE_FORMAT = 'YYYYMMDD';
export const NUMBER_REGEX = /^\d*$/;
